<template>
  <div class="microelements">

    <Head :title="$ml.get(`Microelement Content`)" />

    <div>
      <app-text-input
        v-for="(key, i) in micro"
        :key="i"
        v-model="general.data.ElementsConcentration[key+'_Val']"
        type="number"
        :label="key"
        hint="(%)"
        min="0"
        max="100"
        :digits-after-dot="2"
      />
    </div>
  </div>
</template>

<script>
import Head from './helps/Head.vue';

export default {
  props: {
    general: Object
  },
  data () {
    return {
      micro: ['B', 'Fe', 'Mn', 'Zn', 'Cu', 'Mo']
    }
  },
  components: {
    Head
  }
}
</script>

<style lang="scss" scoped>
  .microelements {
    width: 100%;

    > div:not(.head) {
      width: 100%;
      margin-right: -15px;
      margin-left: -15px;
      &:first-child {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
      }
      &:last-child {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        margin-top: 30px;

        > div {
          width: 96px;
          margin: 15px;
          padding: 1px;
        }
      }
    }
    @media (max-width:768px) {
      .v-check {
        margin: 16px 0;
      }
      > div:last-child {
        justify-content: space-between;
        > div {
          width: calc(50% - 8px);
          margin: 0 0 32px 0;
        }
      }
    }
  }
</style>
